import { Component } from '@angular/core';
import {BaseView} from '../../../../../../core/view/base.view';
import {FormGroup, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {SaleInvoiceModel} from '../../../api/entity/saleInvoice.model';
import {
  SaleInvoiceConfigurationFindOneByAccountBusinessCodeService
} from '../../../modules/configuration/impl/service/saleInvoiceConfigurationFindOneByAccountBusinessCode.service';
import {SaleInvoiceConfigurationModel} from '../../../modules/configuration/api/entity/saleInvoiceConfiguration.model';
import {ToastControl} from '../../../../../../../controls/core/toast/toast.control';
import {IDialogComponent} from '../../../../../../common/dialog/iDialog.component';
import {DialogWithInput} from '../../../../../../common/dialog/dialogWithInput';
import {SaleInvoiceSendByEmailActionService} from '../../../api/service/action/saleInvoiceSendByEmailAction.service';
import {SaleInvoiceFindOneByIdService} from '../../../api/service/saleInvoiceFindOneById.service';
import {SaleInvoiceSendByEmailPayload} from '../../../api/service/action/payload/email/SaleInvoiceSendByEmail.payload';
import {
  SaleInvoiceFormatContentActionService, SaleInvoiceFormatContentPayload
} from "../../../api/service/action/saleInvoiceFormatContentAction.service";
import {
  MedicalReportFormatContentPayload
} from "../../../../../../medical/report/impl/service/payload/medicalReportFormatContent.payload";
import {MomentAdapter} from "../../../../../../../shared/utils/moment.utils";

export interface SaleInvoiceSendByEmailDialogInput {
  id: number;
}

export interface SaleInvoiceSendByEmailDialogResult {
  entity: SaleInvoiceModel;
}

@Component({
  selector: 'app-sale-invoice-send-by-email',
  templateUrl: './sale-invoice-send-by-email.page.html',
  viewProviders: [
      SaleInvoiceFindOneByIdService,
      SaleInvoiceConfigurationFindOneByAccountBusinessCodeService,
      SaleInvoiceSendByEmailActionService,
  ],
  providers: [
      SaleInvoiceFormatContentActionService
  ]
})
export class SaleInvoiceSendByEmailPage extends BaseView implements
    IDialogComponent<SaleInvoiceSendByEmailDialogInput, SaleInvoiceSendByEmailDialogResult>{
  dialog: DialogWithInput<SaleInvoiceSendByEmailDialogInput, SaleInvoiceSendByEmailDialogResult>;


  formGroup: UntypedFormGroup;
  contentFormGroup: FormGroup;
  triggerFormGroup: FormGroup;

  saleInvoice: SaleInvoiceModel;
  configuration: SaleInvoiceConfigurationModel;

  initialTo: string;
  initialSubject: string;
  initialContent: string;

  constructor(private formBuilder: UntypedFormBuilder,
              public findOneByIdService: SaleInvoiceFindOneByIdService,
              public findOneConfiguration: SaleInvoiceConfigurationFindOneByAccountBusinessCodeService,
              public service: SaleInvoiceSendByEmailActionService,
              public toastControl: ToastControl,
              public formatContentActionService: SaleInvoiceFormatContentActionService) {
    super();
    this.triggerFormGroup = this.formBuilder.group({});
    this.contentFormGroup = this.formBuilder.group({});
    this.formGroup = this.formBuilder.group({
      content: this.contentFormGroup,
      trigger: this.triggerFormGroup
    });
  }

  saleInvoiceLoaded(entity: SaleInvoiceModel) {
    this.saleInvoice = entity;
    this.initialTo = entity?.sale?.partner?.email;
  }

  configurationLoaded(entity: SaleInvoiceConfigurationModel) {
    this.configuration = entity;
    this.initialContent = entity?.emailConfiguration?.content;
    this.initialSubject = entity?.emailConfiguration?.subject;
  }

  buildPayload = (): SaleInvoiceSendByEmailPayload => {
    const payload = new SaleInvoiceSendByEmailPayload();
    payload.id = this.saleInvoice.summary.id;
    payload.emailContent = this.contentFormGroup.value;
    payload.trigger = this.triggerFormGroup.value;
    return payload;
  }

  buildFormatContentPayload = (): SaleInvoiceFormatContentPayload => {
    return {
      report: {
        partnerId: this.saleInvoice.sale?.partner?.id,
        content: undefined,
        date: MomentAdapter.current().get()
      },
      id: this.saleInvoice.summary.id
    };
  }

  sent() {
    this.toastControl.presentConfirmation('L\'e-mail a été envoyé');
    this.dialog.close({
      entity: this.saleInvoice
    });
  }

  notSent(error: any) {
    this.toastControl.presentError(error, 'L\'e-mail n\'a pas été envoyé');
  }
}
